export { default as TablePaginator } from "./TablePaginator";
